var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8098 4.3901C9.12328 4.81984 8.81432 6.03828 8.92299 6.81233C7.71987 5.54825 7.76911 4.09445 7.76911 2C3.9102 3.30016 4.80766 7.04908 4.69238 8.18744C3.72174 7.47742 3.53823 5.78128 3.53823 5.78128C2.51366 6.25246 2 7.51071 2 8.53128C2 10.9994 4.23842 13 7.00014 13C9.76158 13 12 10.9994 12 8.53128C12 7.06467 10.7949 6.38794 10.8098 4.38987V4.3901Z",
    fill: "#F63D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.c69f79fe0a68ffe45491518ab558d8c1.svg";
export { ForwardRef as ReactComponent };